import { useState } from "react";
import {getUtmParams, isCrmActive, isEmail, isPostHogActive} from "../../utils";
import { getConfig } from "pp-web";
import { useSearchParams } from 'next/navigation';
import {usePostHog} from "posthog-js/react";

const config = getConfig(process.env.NEXT_PUBLIC_PROFILE);


export function useWaitListForm({ persona, campaignName, onClose }) {
    const searchParams = useSearchParams();
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [emailError, setEmailError] = useState("");
    const [success, setSuccess] = useState(null);
    const [error, setError] = useState("");
    const [errorCode, setErrorCode] = useState("");
    const [showLoader, setShowLoader] = useState(false);
    const postHog = usePostHog()

    function resetAndClose(){
        setError("")
        setErrorCode("")
        setSuccess("")
        setShowLoader(false)
        setName("")
        setEmail("")
        setEmailError("")
        onClose && onClose()
    }

    async function handleForm() {
        setError("");

        if (!isEmail(email)) {
            setEmailError("You must provide a valid email");
            return;
        }

        setShowLoader(true);
        try {
            if (isCrmActive()) {
                const utmParams = getUtmParams(searchParams);
                const body = JSON.stringify({name, email, persona, campaignName, utmParams});


                const response = await fetch(`${config.siteApi.apiUrl}/crm/consumer`, {
                    method: 'POST',
                    body,
                });

                if (!response.ok) {
                    const error = await response.json();
                    if (error.code === 100 || response.statusCode === 409) {
                        setErrorCode(error.code);
                    } else {
                        setError(error.message);
                    }

                    return; //known user
                }
            }

            if(isPostHogActive()) {
                postHog.capture("promos_signup", {email, campaignName})
                //successful sign up

                if (!postHog._isIdentified()) {
                    const props = {email}
                    if (name) {
                        props.name = name
                    }

                    postHog.identify(
                        email,
                        props
                    );
                }
                //identify the user
            }

            setSuccess(true);
        } catch (err) {
            setError("Something went wrong!");
            console.error(err);
        } finally {
            setShowLoader(false);
        }
    }

    return {
        name,
        setName,
        email,
        setEmail,
        emailError,
        success,
        error,
        setError,
        errorCode,
        showLoader,
        setSuccess,
        resetAndClose,
        handleForm
    };
}
